export interface TextInputProps {
  value: string
  placeholder?: string | null
  onChange: (value: string) => void
}

/** Free-text answer (e.g. a watch reference number). */
export default function TextInput({
  value,
  placeholder,
  onChange,
}: TextInputProps) {
  return (
    <div className="input-border flex items-center rounded-xl bg-static-white px-6 py-3">
      <input
        className="w-full text-l font-semibold text-primary outline-none placeholder:font-normal placeholder:text-secondary"
        type="text"
        autoComplete="off"
        maxLength={40}
        placeholder={placeholder ?? undefined}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
    </div>
  )
}
